import ReactApexChart from "react-apexcharts"
import "./chart.css"

export function Chart() {
    const chartData = {
        series: [{
            name: 'series1',
            data: [31, 40, 28, 51, 42, 109, 100]
        }],
        options: {
            chart: {
                height: 315,
                type: 'area',
                fontFamily: "Poppins",
                toolbar: {
                    show: false
                },
            },
            colors: ["#db4444", "#01ff66"],
            dataLabels: {
                enabled: false
            },
            stroke: {
                curve: 'smooth'
            },
            xaxis: {
                type: 'datetime',
                categories: [
                    "2018-09", "2018-10", "2018-11", "2018-12", "2019-01", "2019-02-19T05:30:00.000Z", "2019-03-19T06:30:00.000Z"
                ],
                labels: {
                    style: {
                        fontSize: "16px",
                        fontWeight: "bold",
                    },
                    datetimeFormatter: {
                        year: 'MMM',
                        month: 'MMM',
                        day: 'dd MMM',
                        hour: 'HH:mm'
                    },
                }
            },
            yaxis: {
                labels: {
                    style: {
                        fontSize: "16px"
                    },
                    formatter: function(value) { return `$${value}` } 
                }
            },
            tooltip: {
                x: {
                    format: 'dd/MM'
                },
            },
        },
    }

    return (
        <div className="border rounded-1 chart-container p-3">
            <div className="d-flex justify-content-between align-items-center section-header mx-3 pb-2">
                <div className="">Sales Graph</div>
                <div className="d-flex gap-2 chart-period">
                    <div className="rounded-1 fs-6">Weekly</div>
                    <div className="rounded-1 fs-6">Monthly</div>
                    <div className="rounded-1 fs-6">Yearly</div>
                </div>
            </div>
            <div id="chart">
                <ReactApexChart
                    options={chartData.options}
                    series={chartData.series}
                    type="area"
                    width="100%"
                    height={300}
                />
            </div>
            <div id="html-dist"></div>
        </div>
    )
}